<template>
  <div :class="[
    chosenType != 0 && chosenType != 3
      ? 'app_container back'
      : chosenType == 3
        ? 'app_container back2'
        : chosenType == 0
          ? 'app_container'
          : 'app_container back1',
  ]">
    <div class="top_title" v-show="chosenType != 6">
      <img src="../../assets/satistics/img-title2.png" alt="" class="top_title_img" />
      <div class="title_text">灵峰村数字乡村大数据平台</div>
      <div class="left_light"></div>
      <div class="right_light"></div>
    </div>

    <div class="content_pad">
      <page-info v-if="chosenType == 0"></page-info>
      <page-monitor v-else-if="chosenType == 2"></page-monitor>
      <page-enviroment v-else-if="chosenType == 1"></page-enviroment>
      <page-properties v-else-if="chosenType == 3"></page-properties>
      <page-operation v-else-if="chosenType == 4"></page-operation>
      <!-- <page-map v-else-if="chosenType==6" ></page-map> -->
      <!-- <page-map  ></page-map> -->
    </div>

    <div class="fixed_buttom fixed_buttomtwo" v-show="chosenType != 6">
      <div class="relative_content">
        <img src="../../assets/satistics/img-bottom1.png" alt="" class="bottom_img" />
        <div class="outer_pad">
          <div class="button_item" v-for="(item, index) in buttonList" :key="index" @click="changeType(index)">
            <div class="button_text" :class="{ active: chosenType == index }">
              {{ item }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="map_button map_button1" @click="gomap" v-show="chosenType == 0">
      <img src="../../assets/map4.png" alt="" class="map_icon" />
    </div>
  </div>
</template>

<script>
export default {
  name: "statistics",
  data() {
    return {
      bottomVisible: true,
      chosenType: 0,
      isshowtab: true,
      now: new Date(),
      intervalId: null,
      buttonList: [
        "首页",
        "生态人居",
        "环境监测",
        "三资管理",
        "消防安全",
        "智慧农业",
        "后台管理",
      ],
      gif1: require("../../assets/satistics/gif-page-back.gif"),
      gif2: require("../../assets/satistics/gif-page-back.gif"),
    };
  },
  components: {
    pageInfo: () => import("./infoSec.vue"),
    pageMonitor: () => import("./monitorSec.vue"),
    pageEnviroment: () => import("./enviromentSec.vue"),
    pageProperties: () => import("./propertiesSec.vue"),
    pageOperation: () => import("./operationSec.vue"),
    pageMap: () => import("./map"),
  },
  computed: {
    nowTime: function () {
      let hour =
        this.now.getHours() > 9
          ? this.now.getHours()
          : "0" + this.now.getHours();
      let minute =
        this.now.getMinutes() > 9
          ? this.now.getMinutes()
          : "0" + this.now.getMinutes();
      let second =
        this.now.getSeconds() > 9
          ? this.now.getSeconds()
          : "0" + this.now.getSeconds();

      return hour + ":" + minute + ":" + second;
    },
  },
  created() {
    // this.intervalID = setInterval(() => {
    //   this.now = new Date()
    // }, 1000)
  },
  beforeDestroy() {
    // clearInterval(this.intervalID)
  },
  methods: {
    visibleChange(bool) {
      this.bottomVisible = !bool;
    },

    changeType(index) {
      // this.chosenType = index;
      if (index == this.buttonList.length - 1) {
        this.goIndex();
      } else if (index == this.buttonList.length - 2) {
        window.open('https://www.crop-data.cn/ragis_server_hexinyun/user/singleLogin?userName=相城区农业农村局&password=f6a5295803c62d9f3c803d63768db569')
      } else {
        this.chosenType = index;
      }
    },

    goIndex() {
      this.$router.replace("/home");
    },
    gomap() {
      // this.$router.replace('/map')
      this.$router.replace("/mapSec");
    },
  },
};
</script>

<style scoped lang="less">
@font-face {
  font-family: PingFang-Medium;
  src: url("~@/fonts/PingFang-Medium.ttf");
}

.map_button {
  position: absolute;
  right: 1rem;
  top: 90%;
  width: 70px;
  z-index: 500;
  /*background: red;*/
  display: flex;
  align-items: center;
  /*border-radius: 4px 4px 15px 15px;*/
  /*background: linear-gradient(to right, rgba(28, 108, 190, 1), rgba(8, 152, 219, 1));*/
  /*padding: 0.2rem 0.6rem;*/
  cursor: pointer;
  user-select: none;

  .map_icon {
    width: 100%;
  }

  .map_text {
    flex: 1;
    font-size: 20px;
    margin: 0 6px;
    color: #fff;
  }

  .map_icon_right {
    width: 15%;
  }
}

@font-face {
  font-family: myTitle;
  src: url("/font/title.ttf");
}

@font-face {
  font-family: myDigib;
  src: url("/font/DS-DIGIB.TTF");
}

@font-face {
  font-family: myNum;
  src: url("/font/number.ttf");
}

@media screen and (max-width: 1699px) {
  .title_text {
    font-size: 32px;
  }
}

@media screen and (min-width: 1700px) {
  .title_text {
    font-size: 34px;
  }
}

@media screen and (min-width: 1800px) {
  .title_text {
    font-size: 36px;
  }
}

@media screen and (min-width: 1920px) {
  .title_text {
    font-size: 38px;
  }
}

.back {
  background-image: url("../../assets/satistics/bg7.gif");
}

.back1 {
  background-image: url("../../assets/satistics/gif-page-back.gif");
}

.back2 {
  background-image: url("../../assets/satistics/gif-page-back2.gif");
}

.app_container {
  position: relative;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 0;
  /*background: rgb(200, 0, 0);*/
  /*background: pink;*/
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 900px;
  min-width: 1600px;

  .top_title {
    position: relative;
    width: 100%;
    left: 50%;
    transform: translate(-50%, -36%);
    z-index: 2;

    .top_title_img {
      width: 100%;
    }

    .top_title_effect {
      position: absolute;
      left: 50%;
      top: 32%;
      transform: translate(-50%, 0);
    }

    .title_text {
      position: absolute;
      font-size: 55px;
      font-weight: 600;
      color: #ffffff;
      letter-spacing: 6px;
      text-shadow: 2px 3px 0px #0f298b;
      top: 44%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .left_light {
    position: absolute;
    left: 30%;
    top: 43%;
    width: 45px;
    height: 2px;
    background: linear-gradient(to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 1) 25%,
        rgba(255, 255, 255, 1) 75%,
        rgba(255, 255, 255, 0) 100%);
    animation: leftMove 3s linear 0s infinite;
    z-index: 100;
  }

  .right_light {
    position: absolute;
    right: 30%;
    top: 43%;
    width: 45px;
    height: 2px;
    background: linear-gradient(to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 1) 25%,
        rgba(255, 255, 255, 1) 75%,
        rgba(255, 255, 255, 0) 100%);
    animation: rightMove 3s linear 0s infinite;
    z-index: 100;
  }

  .app_header {
    position: absolute;
    top: 0;
    left: 0;
    height: 9%;
    width: 100%;
    z-index: 100;
    background: linear-gradient(to bottom,
        rgba(22, 48, 106, 0.36) 0%,
        rgba(255, 0, 0, 0) 70%);

    .title_img {
      width: 100%;
      height: 100%;
    }

    .title_text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) skew(-10deg);
      color: #ffffff;
      line-height: 52px;
      font-weight: 600;
      letter-spacing: 2px;
    }

    .time_text {
      position: absolute;
      top: 0.3rem;
      left: 1.2rem;
      font-size: 22px;
      color: #fff;
    }
  }

  .content_pad {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
  }

  .fixed_buttom {
    position: fixed;
    left: 50%;
    bottom: 0%;
    transform: translate(-50%, 15%);
    width: 75%;
    background: linear-gradient(to top,
        rgba(22, 48, 106, 0.36) 0%,
        rgba(255, 0, 0, 0) 70%);
    z-index: 300;

    .relative_content {
      position: relative;
      width: 100%;

      .bottom_img {
        width: 100%;
      }

      .outer_pad {
        position: absolute;
        bottom: 20%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 56%;
        height: 88%;
        padding: 0 25px;

        background-image: url(../../assets/satistics/bottom_bg.png);
        background-size: 100% 100%;

        .button_item {
          position: relative;
          cursor: pointer;
          width: 100%;
          height: 100%;
        }

        .button_text {
          font-size: 20px;
          font-family: PingFang-Medium;
          font-weight: 600;
          color: #acb3f4;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          &.active {
            color: #ffffff;
            background-image: url(../../assets/satistics/bottom_sel.png);
            background-size: 100% 100%;
          }
        }
      }
    }
  }
}

@keyframes leftMove {
  0% {
    left: 24%;
  }

  50% {
    left: 12%;
  }

  100% {
    left: 24%;
  }
}

@keyframes rightMove {
  0% {
    right: 24%;
  }

  50% {
    right: 12%;
  }

  100% {
    right: 24%;
  }
}
</style>
